import React from 'react'
import TransactionDetail from 'src/app/TransactionDetail/TransactionDetail'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import AccountTransactionsAppRoute from 'src/navigation/appRoutes/account/accountTransactions.appRoute'
import BudgetTransactionsAppRoute from 'src/navigation/appRoutes/budget/budgetTransactions.appRoute'
import ExpensesTransactionsAppRoute from 'src/navigation/appRoutes/expenses/expensesTransactions.appRoute'
import { transactionDetailRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const TransactionDetailAppRoute: AppRoute = {
  id: AppLocation.TransactionDetail,
  routeProps: transactionDetailRouteProps,
  component: <TransactionDetail />,
  subRoutes: [],
  exceptions: [
    ExpensesTransactionsAppRoute,
    AccountTransactionsAppRoute,
    BudgetTransactionsAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default TransactionDetailAppRoute
